import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { VhEventMediator, VhImage, VhQueryAutoWeb } from 'vhautowebdb'; 
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-pdf-viewer-config',
  templateUrl: './pdf-viewer-config.component.html',
  styleUrls: ['./pdf-viewer-config.component.scss']
})

export class AtwPdfViewerConfig  {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any;

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  id_subproject: any = "";
  pdfUrl: any;
  pdfTitle: string;
  data_object: any = {};
  selectedFile


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object,
    private vhImage: VhImage
  ) { 
  }

  ngOnChanges() {
    if (!this.staticdata.accessibility) this.staticdata.accessibility = {}; 
    if (isPlatformBrowser(this.platformId))
      this.getData();
  }

  getData() {
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectChoosing.staticdata.src);
    this.pdfTitle = this.staticdata.src.split('/').pop().split('.pdf')[0].replace(/%20/g, ' ');
  }

  /**
  * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
  * @param event width hieght của element sau khi thay đổi
  */
  changeWidthHeight(event) {
    if (event.width) this.class['text']['width'] = event.width + 'px';
    if (event.height) this.class['text']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

  /**
  * Hàm update class
  */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }


  /**
  * Hàm này dùng để cho phép mở menu config .
  * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
  * @param: value
  */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };
  update(src) {
    // update
    this.vhQueryAutoWeb
    .updateObject(this.objectChoosing._id, { 
      staticdata: {
        ...this.objectChoosing.staticdata,
        src: src, 
        nameFile: this.selectedFile.name
      }
     })
    .then(
      (bool) => {

        this.functionService.createMessage("success", "Thay đổi file thành công");
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(src);
        this.data_object.nameFile = this.selectedFile.name;

      },
      (error) => {

        this.functionService.createMessage("error", error);

      }
    );
  }

  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  }

  onFileSelected(event) {
    // nếu là cập nhật file thì phải truyền vào oldFileURL
    // kiểm tra xem có lưu file url chưa
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      this.selectedFile = files[0];
      this.vhImage.uploadFileFromDesktop(this.selectedFile, 'file-pdf', this.data_object?.src || null, 20000000)
        .then((rsp: any) => {
          if (rsp.vcode === 0) {
            this.update(rsp.data + '#view=FitH');
          } else
            this.functionService.createMessage("error", "Tải file thất bại! Lý do: " + rsp.message);
        }, error => {
          this.functionService.createMessage("error", "Tải file thất bại");
        }
        );
    }

  }

}
